<template lang="pug">
.card-container(
  @click="click"
  :class="[ \
      (info.subtitle && info.marketingWords && info.marketingWords.length>0) ? 'addHeight' : '', \
    ]",
)
  .left
    img(:src="imgUrl")
  .right
    span.title {{ info.title }}
    span.text(v-if="info.subtitle") {{ info.subtitle }}
    .words(v-if="info.marketingWords&&info.marketingWords.length>0")
      span.word-item(v-for="word in info.marketingWords.slice(0, 2)") {{word.wordsValue}}
    div.bottom
      span.money.first ¥
      span.price {{ info.currentPrice }}
      span.small-money.del ¥
      span.original.del {{ info.originPrice }}
  template(v-if="rob")
    .rush
      .save 省{{info.diff}}元
      .go-rush 马上抢
</template>

<script>
export default {
  props: {
    rob: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: true,
    },
    info: {
      type: Object,
      default: null,
    },
  },
  computed: {
    imgUrl() {
      return this.info && this.info.businessType === 2
        ? 'https://m.hellobike.com/resource/AppPlatformH5/card-for-app/jZr-dd5rUdIVzlP5ikRRa.png'
        : 'https://m.hellobike.com/resource/AppPlatformH5/card-for-app/nfpewIhaG0Q1JtBLBJmLv.png';
    },
    flag() {
      return this.info.subtitle;
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.card-container {
  display: flex;
  position: relative;
  justify-content: space-between;
  width: 3.27rem;
  height: 1.05rem;
  padding-left: 0.08rem;
  padding-top: 0.16rem;
  background: #fff;
  box-shadow: 0 0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
  border-radius: 0.08rem;

  .left {
    width: 0.56rem;
    height: 0.62rem;
    margin-right: 0.1rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 0.16rem;
      line-height: 1;
      font-weight: 500;
      color: #242729;
      margin-bottom: 0.08rem;
      white-space: nowrap;
      max-width: 2.4rem;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-top: -0.01rem;
    }

    .words {
      display: flex;
      white-space: nowrap;
      margin-bottom: 0.03rem;

      .word-item {
        display: inline-block;
        background: #ebfbff;
        font-size: 0.12rem;
        line-height: 0.16rem;
        color: #08f;
        font-weight: 400;
        padding: 0.02rem 0.04rem;
        border-radius: 0.04rem;

        &:not(:last-of-type) {
          margin-right: 0.08rem;
        }
      }
    }

    .text {
      height: 0.16rem;
      font-size: 0.11rem;
      font-weight: 400;
      color: #242729;
      line-height: 0.16rem;
      position: relative;
      top: -0.03rem;
    }

    .bottom {
      position: relative;

      .first {
        position: relative;
        top: -0.01rem;
      }

      .money {
        height: 0.17rem;
        font-size: 0.12rem;
        font-weight: 500;
        color: #ff5103;
        line-height: 0.17rem;
        margin-right: 0.02rem;
      }

      .small-money {
        height: 0.17rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.17rem;
      }

      .price {
        width: 0.38rem;
        height: 0.16rem;
        font-size: 0.2rem;
        font-weight: 600;
        color: #ff5103;
        line-height: 0.16rem;
        margin-right: 0.05rem;
      }

      .original {
        width: 0.15rem;
        height: 0.17rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.17rem;
      }
    }
  }

  .rush {
    border: 0.01rem solid #ff9a8b;
    min-width: 1.03rem;
    height: 0.28rem;
    background: #fff5f1;
    border-radius: 0.16rem;
    position: absolute;
    right: 0.08rem;
    top: 0.65rem;
    display: flex;

    .save {
      line-height: 0.28rem;
      text-align: left;
      font-size: 0.12rem;
      margin-right: -0.06rem;
      font-weight: 500;
      color: #ff5103;
      padding-left: 0.08rem;
      display: inline-block;
      flex: 1;
    }

    .go-rush {
      line-height: 0.28rem;
      text-align: center;
      padding-left: 0.1rem;
      font-size: 0.12rem;
      font-weight: 500;
      color: #fff;
      width: 0.63rem;
      border-top-right-radius: 0.16rem;
      border-bottom-right-radius: 0.16rem;
      background-image: url("https://m.hellobike.com/resource/AppPlatformH5/card-for-app/0ar6Al7X6jtMUdGboLzDx.png");
      background-size: 0.63rem 0.28rem;
      background-repeat: no-repeat;
      height: 0.28rem;
      position: relative;
      top: -0.01rem;
      right: -0.01rem;
    }
  }

  &.addHeight {
    height: 1.2rem;

    .rush {
      position: absolute;
      top: 0.8rem !important;
    }

    .right .words {
      margin-top: 0.03rem;
    }
  }
}
</style>
